import React from 'react';
import ChartComponent from './ChartComponent';

const AverageRatingChart = ({ data }) => {
  const aggregationTemplate = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

  const aggregation = { ...aggregationTemplate };
  data.forEach((review) => {
    const { rating } = review;
    if (rating >= 1 && rating <= 5) {
      aggregation[rating] += 1;
    }
  });

  const chartData = {
    labels: ['1', '2', '3', '4', '5'], 
    datasets: [
      {
        label: 'Product Rating',
        data: [aggregation[1], aggregation[2], aggregation[3], aggregation[4], aggregation[5]], 
        backgroundColor: 'rgba(255, 193, 7, 0.6)', // Yellow color to match the star theme
        borderColor: 'rgba(255, 193, 7, 1)', // Border to enhance visual separation
        borderWidth: 2,
        borderRadius: 8, // Rounded edges to make the bars look smoother
      },
    ],
  };

  // Chart options for a cleaner look
  const chartOptions = {
    indexAxis: 'y', // Make the bar chart horizontal
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: 'Product Rating', // Chart title
        font: {
          size: 18,
          weight: 'bold',
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true, // X-axis starts at zero
        title: {
          display: true,
          text: 'Number of Ratings', // X-axis title
          font: {
            size: 14,
          },
        },
        ticks: {
          stepSize: 1, // Increment by 1
          suggestedMin: 0,
        },
        grid: {
          display: false, // Remove grid lines for a cleaner look
        },
      },
      y: {
        title: {
          display: true,
          text: 'Rating', // Y-axis title
          font: {
            size: 14,
          },
        },
        ticks: {
          callback: function (value) {
            return (
              `${value + 1} Star${value + 1 > 1 ? 's' : ''}`
            );
          },
        },
        grid: {
          display: false, // Remove grid lines
        },
      },
    },
  };

  return (
    <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <ChartComponent type="bar" data={chartData} options={chartOptions} />
    </div>
  );
};

export default AverageRatingChart;
